/**
 * Love Store Paris — Limite bon d'achat Offre VIP à 1 par panier
 */
(function () {
  'use strict';

  var VIP_HANDLES = ['offre-vip', 'bon-achat-offre-vip-389'];
  var MAX_QTY = 1;

  function isVipHandle(handle) {
    return VIP_HANDLES.indexOf(String(handle || '')) !== -1;
  }

  function isVipCartItem(item) {
    if (!item) return false;
    return isVipHandle(item.handle) || isVipHandle(item.product_handle);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      return response.json();
    });
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: MAX_QTY }] })
    }).then(function (response) {
      return response.json();
    });
  }

  function findVipLines(cart) {
    return (cart.items || []).filter(isVipCartItem);
  }

  function enforceCartLimits() {
    return fetchCart()
      .then(function (cart) {
        var fixes = findVipLines(cart)
          .filter(function (item) {
            return item.quantity > MAX_QTY;
          })
          .map(function (item) {
            return changeLine(item.key, MAX_QTY);
          });

        return Promise.all(fixes);
      })
      .catch(function () {});
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function addVipAndCheckout(variantId) {
    return fetchCart().then(function (cart) {
      var vipLines = findVipLines(cart);
      var sameVariant = (cart.items || []).find(function (item) {
        return String(item.variant_id) === String(variantId);
      });

      if (sameVariant) {
        if (sameVariant.quantity > MAX_QTY) {
          return changeLine(sameVariant.key, MAX_QTY).then(goToCheckout);
        }
        goToCheckout();
        return;
      }

      if (vipLines.length > 0) {
        goToCheckout();
        return;
      }

      return addToCart(variantId).then(function (data) {
        if (data.status && data.description) {
          throw new Error(data.description);
        }
        goToCheckout();
      });
    });
  }

  function lockCartDrawerQuantities() {
    fetchCart()
      .then(function (cart) {
        cart.items.forEach(function (item, index) {
          if (!isVipCartItem(item)) return;

          var drawerInput = document.getElementById('Drawer-quantity-' + (index + 1));
          if (drawerInput) {
            drawerInput.setAttribute('max', String(MAX_QTY));
            if (parseInt(drawerInput.value, 10) > MAX_QTY) {
              drawerInput.value = String(MAX_QTY);
            }
          }

          var line = document.getElementById('CartDrawer-Item-' + (index + 1));
          if (!line) return;

          var plusBtn = line.querySelector('quantity-input button[name="plus"]');
          if (plusBtn) {
            plusBtn.disabled = item.quantity >= MAX_QTY;
            plusBtn.setAttribute('aria-disabled', item.quantity >= MAX_QTY ? 'true' : 'false');
          }
        });
      })
      .catch(function () {});
  }

  function initFetchHook() {
    if (!window.fetch || window.fetch.__lspOffreVipLimitPatched) return;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var isCartMutation =
        typeof url === 'string' &&
        (url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartMutation && response.ok) {
          enforceCartLimits().then(lockCartDrawerQuantities);
        }
        return response;
      });
    };

    window.fetch.__lspOffreVipLimitPatched = true;
  }

  window.LspOffreVipCart = {
    VIP_HANDLES: VIP_HANDLES,
    MAX_QTY: MAX_QTY,
    isVipHandle: isVipHandle,
    isVipCartItem: isVipCartItem,
    enforceCartLimits: enforceCartLimits,
    addVipAndCheckout: addVipAndCheckout
  };

  initFetchHook();

  document.addEventListener('DOMContentLoaded', function () {
    enforceCartLimits().then(lockCartDrawerQuantities);
  });

  document.addEventListener('cart:updated', function () {
    enforceCartLimits().then(lockCartDrawerQuantities);
  });
})();
